export const environment = {
  production: true,
  google_maps_api_key: "AIzaSyDqBmqdRY9UUO9yTPvUfcwsl1lYogY0NJc"
};
